import React from 'react';
import TicketStub from '../';
import RemoveHeader from '../ticket_stub_remove_header';
import TicketStubContent from '../content';
import TicketStubOutline from '../outline';
import TicketStubInfo from '../ticket_stub_info';

const T = React.PropTypes;

export default class BasketTemplate extends React.Component {
  static propTypes = {
    onClick: T.func,
    ticket: T.object,
    children: T.node
  };

  render () {
    return <TicketStub>
      <TicketStubOutline isBlue ovalColorClass="ticket_stub_outline__oval--my_tickets_gray" />
      <RemoveHeader onClose={this.props.onClick} ticket={this.props.ticket} />
      <TicketStubContent dataComponent="ticket_stub">
        <TicketStubInfo>
          {this.props.children}
        </TicketStubInfo>
      </TicketStubContent>
    </TicketStub>;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/templates/basket_template.js